import React, { useEffect, useState } from 'react';
import MainLayout from '../../Layout/main';
import { PagePolicyInterface } from '../../Services/types';

import Header from '../../Components/header-interna';

import { Helmet } from 'react-helmet-async';
import { fetchData } from '../../../Api';

const Politica: React.FC<any> = ({initialData} : any) => {

    const [policy, setPolicy] = useState<PagePolicyInterface | null>(initialData?.politicas);
    const [title, setTitle] = useState<string>("");

    useEffect(() => {
        if (initialData) return;
        const loadData = async () => {
            const response = await fetchData("politicas");
            if(response){
                if (response.politicas) setPolicy(response.politicas);
            }
        };
        
        loadData();
    }, []);

    useEffect(() => {
        if(policy)
            setTitle(policy.title);
        else
            setTitle("");
    }, [policy]);

    const breadcrumb = [{
        name: title,
        slug: 'politica-de-privacidade'
    }];
    
    return (
        <>
            <Helmet>
                <title>{title} - Uniexpo</title>
            </Helmet>

            <MainLayout>
                <Header title={title} breadcrumb={breadcrumb} />

                <section className="pt-8 pb-12">
                    <div className="max-w-screen-xl mx-auto px-4">
                        {policy && 
                            <div className="text-justify text-sm 2xl:text-base" dangerouslySetInnerHTML={{ __html: policy.content }} />
                        }
                    </div>
                </section>
            </ MainLayout>
        </>
    );
};

export default Politica;
